import { FaMapMarkerAlt, FaAngleDown, FaAngleUp, FaCalendarCheck } from 'react-icons/fa'
import { BackgroundCollapse, CardBody, ColumnText, HeaderSection, PreViewParticipante, SectionAssociados, SectionBody } from './styles'
import { useState } from 'react'
import { iParticipanteFeedbackResponse, iPostAvaliador } from '../../../../../interfaces'
import { Avatar, Flex } from '@chakra-ui/react'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { CardAssociado } from '../CardAssociado'

interface iCardProps {
  Avaliacao: iParticipanteFeedbackResponse
  onEdit: (avaliador: iPostAvaliador) => void
  onOpenModal: (tipo: number, avaliacaoId: string) => void
  disabled: boolean
  temPDI: boolean
  onOpenJaTrabalhadas: (avaliacaoId: string, avaliador?: iPostAvaliador) => void
}

export const CardParticipante: React.FC<iCardProps> = ({ Avaliacao, onOpenModal, onEdit, disabled, onOpenJaTrabalhadas, temPDI }) => {
  const [isOpen, setisOpen] = useState(false)
  function ObterTotal(): number {
    let i: number = 0

    const pares = Avaliacao.respondentesPesquisa?.filter(e => e.tipoAvaliador === 2)
    const lider = Avaliacao.respondentesPesquisa?.filter(e => e.tipoAvaliador === 1)
    const altaLideranca = Avaliacao.respondentesPesquisa?.filter(e => e.tipoAvaliador === 6)
    const liderados = Avaliacao.respondentesPesquisa?.filter(e => e.tipoAvaliador === 3)
    const outros = Avaliacao.respondentesPesquisa?.filter(e => e.tipoAvaliador === 4)

    if (pares) i += pares.length
    if (lider) i += lider.length
    if (altaLideranca) i += altaLideranca.length
    if (liderados) i += liderados.length
    if (outros) i += outros.length

    return i
  }

  function renderSectionAssociados(tipo: number, titulo: string): any {
    const avaliadores = Avaliacao.respondentesPesquisa?.filter(e => e.tipoAvaliador === tipo) ?? []

    return (
      <SectionAssociados>
        <HeaderSection>
          <h4>{titulo}({avaliadores.length})</h4>
          <ButtonCmp VarColor='Rosa' onClick={() => onOpenModal(tipo, Avaliacao.id)}>Adicionar</ButtonCmp>
        </HeaderSection>
        <SectionBody>
          {
            avaliadores.map((e, i) => (
              <CardAssociado
                key={i}
                avaliador={e}
                onEdit={onEdit}
                tipo={tipo}
              />
            ))
          }
        </SectionBody>
      </SectionAssociados>
    )
  }

  return (
      <ElementoTooltipCmp label={''}>
        <BackgroundCollapse active={isOpen}>
          <PreViewParticipante style={disabled ? { opacity: '0.75', cursor: 'not-allowed' } : {}}>
            <CardBody column={2}>
              <Flex>
                <Avatar size={'sm'} src={Avaliacao.colaborador?.avatar} marginRight={'.5rem'} name={Avaliacao.colaborador?.nome} />
                <ColumnText>
                  <h4 style={{ fontSize: '.875rem', fontWeight: 600 }}>{Avaliacao.colaborador?.nome}</h4>
                  <span>Avaliado</span>
                </ColumnText>
              </Flex>
              <Flex alignItems={'center'}>
                <FaMapMarkerAlt size={26} style={{ marginRight: '.325rem' }} />
                <ColumnText>
                  <h3 style={{ fontSize: '1rem', lineHeight: '1rem', fontWeight: 600 }}>{ObterTotal()}</h3>
                  <span>Avaliadores</span>
                </ColumnText>
              </Flex>
            </CardBody>
            <Flex alignItems={'center'} mr={'1rem'} gap={'1rem'}>
              {temPDI && <ButtonCmp VarColor={'Rosa'} onClick={() => onOpenJaTrabalhadas(Avaliacao.colaborador?.id ?? '')} leftIcon={<FaCalendarCheck color='var(--c1)'/>}>Competências utilizadas no PDI</ButtonCmp>}
              <ButtonCmp disabled={disabled} rightIcon={!isOpen ? <FaAngleDown color='var(--c1)'/> : <FaAngleUp color='var(--c1)'/>} VarColor='Green2' onClick={() => setisOpen(!isOpen)}>{!isOpen ? 'Visualizar' : 'Minimizar'}</ButtonCmp>
            </Flex>
          </PreViewParticipante>
          <Flex flexDir={'column'} padding='.5rem .75rem 0rem .75rem'>

            {renderSectionAssociados(1, 'Gestor')}
            {renderSectionAssociados(2, 'Pares')}
            {renderSectionAssociados(4, 'Outros')}
            {renderSectionAssociados(6, 'Alta liderança')}
            {renderSectionAssociados(3, 'Liderados')}

          </Flex>
        </BackgroundCollapse>
      </ElementoTooltipCmp>
  )
}
